// src/Navbar.js
import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import "./manufacturing.css";
import Footer from "../components/Footer";

import Button from "react-bootstrap/Button";

import Icon1 from "../assets/Industry/Product.png"
import Icon2 from "../assets/Industry/NotificationCenter.png"
import Icon3 from "../assets/Industry/CheckedCheckbox.png"
import Icon4 from "../assets/Industry/PositiveDynamic.png"

import Navbar from "../components/Navbar";

const Retail = () => {
  const navigate= useNavigate()
  const [activeTab, setActiveTab] = useState("resourceTracking");

  const content = {
    resourceTracking: {
      title: "ENHANCED CUSTOMER EXPERIENCE",
      description: [
        "Track foot traffic patterns and dwell times to understand shopper preferences.",
        "Identify suspicious behaviours in real-time to minimize theft and loss.",
        "Use behavioural data to predict which products will drive sales in specific demographics.",
      ],
      image: "retail 2.jpg",
    },
    riskManagement: {
      title: "PROACTIVE OPTIMIZATION & INSIGHTS",
      description: [
        "Adjust inventory levels proactively based on predicted seasonal trends.",
        "Use predictive analytics to optimize restocking schedules based on demand.",
        "View live sales metrics, customer insights, and inventory status at a glance.",
      ],
      image: "retail 3.jpg", // Replace with your image URL or import it
    },
    smartAutomation: {
      title: "MAINTAINING OPTIMAL STOCK LEVEL",
      description: [
        "Detect when shelves need restocking or rearranging without manual checks.",
        "Ensure product quality by scanning items for defects or inconsistencies upon arrival.",
        "Monitor stock levels automatically to avoid overstocking or stockouts.",
      ],
      image: "retail 4.jpg",
    },
    dataDrivenInsights: {
      title: "INTELLIGENT SURVEILLANCE ",
      description: [
        "Detect accidents or unsafe conditions and automatically alert staff for immediate response.",
        "Analyze crowd density and movement patterns to enhance safety and optimize store layout.",
        "Monitor store environments for suspicious activities or potential theft.",
      ],
      image: "100001549.jpeg",
    },
  };

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>

      <div className="container-mirrored">
        <div className="image-section-mirrored">
          <img src="78544566.png" alt="Product Line"/>
        </div>
        <div className="content-mirrored">
          <h1>Turns out, your store’s got a lot to say.</h1>
          <h4 style={{ fontWeight: "300" }}>
            Think of it as a backstage pass to your customer’s journey—from
            first step to final sale.
          </h4>
          <Button
            onClick={()=>{navigate('/Demo')}}
            // href="https://forms.gle/P7B2NMVwGstAeVea8"
            className="know-more-btn"
          >
            Get Started
            <style>
            
            </style>
          </Button>
        </div>
      </div>

      <div className="centered-section">
        <h2>Know what’s catching eyes—and what’s getting skipped. </h2>
        <h6>
          ​This is how better insights enhance customer engagement, optimize
          inventory, and drive sales growth.
        </h6>
      </div>

      <div className="app2">
        <div className="tabs2">
          {Object.keys(content).map((tabKey) => (
            <button
              key={tabKey}
              className={`tab2 ${activeTab === tabKey ? "active2" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {content[tabKey].title.split(" & ")[0]}
            </button>
          ))}
        </div>

        <div className="content2">
          <div className="text-column2">
            <h2>{content[activeTab].title}</h2>
            <hr />
            <p>
              {content[activeTab].description.map((desc, index) => (
                <div key={index}>• {desc}</div>
              ))}
            </p>
          </div>
          <div className="image-column2">
            <img
              src={content[activeTab].image}
              alt={content[activeTab].title}
            />
          </div>
        </div>
      </div>

      <div className="app-container2">
        <header className="app-header2">
          <h1 className="title2">Our Story in Numbers</h1>
        </header>

        <div className="statistics-container2">
          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+15%</h2>
            <p className="statistic-description21">Sales per Sqaure Foot</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              Through Customer Engagement Strategies
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+25%</h2>
            <p className="statistic-description21">Customer Conversion Rate</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Through Peak Footfall Rate</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+40%</h2>
            <p className="statistic-description21">Customer Retention Rate</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Personalised Experiences</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-50%</h2>
            <p className="statistic-description21">Inventory Shrinkage</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              Better Tracking & Security Measure
            </p>
          </div>
        </div>
      </div>

      <div className="app-container3">
        <div className="content3" style={{ textAlign: "left" }}>
          <h1 className="title3">
            Streamline Your Retail Operations with Argus
          </h1>
          <Button
            onClick={()=>{navigate('/contact')}}
            className="connect-button3"

          >
            Connect Now
          </Button>
        </div>

        <div className="card-container3">
          <div className="card3">
            <div className="icon3">
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Automated Shelf Scanning to prevent stockouts.​
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Real-Time Alert for prevent Operational Disruption
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Faster Checkouts with Reduced Wait times.
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon4} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Data-driven Merchandising to Optimize & Boost sales.
            </h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Retail;
